/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button } from "@mui/material";
import { Image } from "@mui/icons-material";

const DialogButton = (props) => {

    const setOpen = props.setOpen;
    const openModelDialog = () => {
        setOpen(true);
    };

    return (
        <Fragment>
            <Button
                color='primary'
                variant='contained'
                onClick={openModelDialog}
            >
                <Image style={{ marginRight: "8px" }} />
                Select Model
            </Button>
        </Fragment>
    );
};

export default DialogButton;
